{
  "nav": {
    "home": "Startseite",
    "pick": "Auswahl",
    "leaderboard": "Rangliste",
    "profile": "Profil",
    "leagues": "Ligen",
    "active_league": "Aktive Liga"
  },
  "common": {
    "error_data": "Fehler beim Laden der Daten.",
    "stage": "Etappe",
    "go": "LOS",
    "back": "← Zurück",
    "one_day_race": "Eintagesrennen",
    "tomorrow": "Morgen",
    "in_days_one": "Morgen",
    "in_days_many": "In {{count}} Tagen",
    "in_days_other": "In {{count}} Tagen",
    "at_hours": "Um {{hours}} Uhr",
    "loading": "Wird geladen...",
    "confirm": "BESTÄTIGEN",
    "logout": "ABMELDEN",
    "in_days": "In {{count}} Tagen",
    "error_generic": "Es ist ein Fehler aufgetreten.",
    "optional": "optional",
    "tu": "DU",
    "error_title": "Fehler",
    "send": "Senden",
    "retry": "Erneut versuchen",
    "load_error_title": "Daten konnten nicht geladen werden",
    "load_error_sub": "Prüfe deine Verbindung und versuche es erneut.",
    "stale_data": "Daten evtl. nicht aktuell: gespeicherte Daten werden gezeigt."
  },
  "home": {
    "participants": "Teilnehmer",
    "section_results": "Letzte Ergebnisse",
    "section_upcoming": "Nächste Rennen",
    "social": "Folge uns in den sozialen Medien",
    "onboarding_next": "Weiter →",
    "onboarding_start": "Jetzt spielen →",
    "onboarding_rules": "Regelwerk lesen",
    "section_picks": "Ausstehende Auswahlen",
    "no_races": "Aktuell nichts zum Auswählen",
    "other_picks_one": "eine weitere Auswahl zu treffen →",
    "other_picks_many": "{{count}} weitere Auswahlen zu treffen →",
    "other_picks_other": "{{count}} weitere Auswahlen zu treffen →",
    "stage_results": "Rangliste",
    "tab_stage": "ETAPPE",
    "tab_gc": "GESAMT",
    "no_data": "Keine Daten verfügbar",
    "onboarding_step1_title": "Willkommen bei Virtua Cycling!",
    "onboarding_step1_body": "Das Fantasy-Spiel des Profiradsports.",
    "onboarding_step2_title": "So funktioniert's",
    "onboarding_item1": "Wähle deine Fahrer — Vor jeder Etappe wählst du die Fahrer, auf die du setzt. Zeit hast du bis zum Start.",
    "onboarding_item2": "Sammle Punkte — Deine Fahrer erhalten Punkte je nach ihrer tatsächlichen Platzierung in der Etappe und der Gesamtwertung.",
    "onboarding_item3": "Erstelle deine Liga — Miss dich etappenweise mit anderen Teilnehmern und klettere in der Gesamtwertung nach oben.",
    "onboarding_step3_title": "Du bist bereit!",
    "onboarding_step3_body": "Du bist in der Virtua Cycling League, der allgemeinen Liga, in der alle spielen. Lies das vollständige Regelwerk, um nichts zu verpassen.",
    "kofi_cta": "Gefällt dir die App? Spendier uns ein Bier!",
    "jersey_gc": "Gesamtführungstrikot",
    "jersey_pt": "Punktetrikot",
    "jersey_gm": "Bergtrikot",
    "greeting": "Hallo, {{name}}",
    "status_ready": "Tipps für die nächste Etappe bestätigt",
    "status_todo": "Du hast deine Tipps noch nicht abgegeben",
    "retry": "Erneut versuchen"
  },
  "pick": {
    "live_label": "LIVE",
    "pick_done": "Auswahl bereits getroffen — du kannst sie noch ändern",
    "no_pick_stage": "Für diese Etappe wurde keine Auswahl gefunden.",
    "error_load": "Fehler beim Laden der Rennen.",
    "loading": "Wird geladen...",
    "title": "Auswahl",
    "no_races_title": "Kein Rennen verfügbar",
    "no_races_sub": "Derzeit ist kein Rennen geplant. Schau bald wieder vorbei!",
    "banned_title": "Rückzug vom Rennen",
    "banned_stages_one": "Du hast 1 Etappe verpasst",
    "banned_stages_many": "Du hast {{count}} Etappen verpasst",
    "banned_stages_other": "Du hast {{count}} Etappen verpasst",
    "banned_detail": "Du kannst die Ergebnisse und Auswahlen der anderen verfolgen, aber nicht mehr an dieser Ausgabe teilnehmen.",
    "banned_message": "Bis zum nächsten Mal!",
    "stage_finished": "Etappe beendet. Hier ist die getroffene Auswahl.",
    "live_alert": "Rennen läuft — Aufstellungen fixiert",
    "startlist_btn": "Startliste",
    "startlist_title": "Startliste",
    "startlist_search": "Startnummer oder Name suchen",
    "startlist_dnf": "Ausgestiegen",
    "startlist_empty": "Startliste noch nicht verfügbar",
    "tab_insert": "Eingabe",
    "tab_summary": "Zusammenfassung",
    "start_list_title": "Startliste noch nicht bereit",
    "start_list_sub": "Die Starterliste wird in Kürze veröffentlicht. Schau später noch einmal vorbei.",
    "need_more_one": "Wähle noch {{count}} Fahrer aus.",
    "need_more_many": "Wähle noch {{count}} Fahrer aus.",
    "need_more_other": "Wähle noch {{count}} Fahrer aus.",
    "error_save": "Fehler beim Speichern.",
    "loading_riders": "Fahrer werden geladen...",
    "draft_restored": "Entwurf wiederhergestellt",
    "draft_count_one": "1 Fahrer lokal gespeichert",
    "draft_count_many": "{{count}} Fahrer lokal gespeichert",
    "draft_count_other": "{{count}} Fahrer lokal gespeichert",
    "draft_cancel": "Abbrechen",
    "select_n_one": "Wähle {{count}} Fahrer",
    "select_n_many": "Wähle {{count}} Fahrer",
    "select_n_other": "Wähle {{count}} Fahrer",
    "add_rider": "+ Fahrer hinzufügen ({{current}}/{{limit}})",
    "edit_selection": "Auswahl bearbeiten",
    "apply_all": "Auswahl auf alle meine Ligen anwenden",
    "saved_for": "Gespeichert für: {{leagues}}",
    "flip_used": "Flip — verwendet",
    "flip_available": "Flip — verfügbar",
    "flip_remove": "Entfernen",
    "flip_abbinato": "{{rider}} mit Slot {{slot}} verknüpft",
    "flip_confirmed": "Der Flip wurde für diese Etappe festgelegt. Bei der Punkteberechnung wird der beste Wert gewählt.",
    "flip_slot_label": "Flip mit welchem Slot verknüpfen?",
    "flip_confirm_btn": "Flip bestätigen",
    "saving": "Wird gespeichert...",
    "confirm_pick": "AUSWAHL BESTÄTIGEN {{current}}/{{limit}}",
    "select_riders": "Fahrer auswählen",
    "search_rider": "Fahrer suchen...",
    "no_rider_found": "Kein Fahrer gefunden",
    "compare_users": "Benutzer vergleichen",
    "confirm": "Bestätigen",
    "no_pick_found": "Keine Auswahl gefunden.",
    "toast_multi_one": "Auswahl für 1 Liga gespeichert",
    "toast_multi_many": "Auswahl für {{count}} Ligen gespeichert",
    "toast_multi_other": "Auswahl für {{count}} Ligen gespeichert",
    "toast_single": "Auswahl gespeichert!",
    "compare_with": "Vergleichen mit {{names}}",
    "compare_default": "Mit anderen Benutzern vergleichen (max {{max}})",
    "tap_to_change": "• zum Ändern tippen",
    "you": "(DU)",
    "matrix_hint": "Tippe auf einen Fahrer, um zu sehen, wer ihn getippt hat",
    "user_col": "Benutzer",
    "scout_title": "Scouting-Bericht",
    "scout_top_rider": "Meistgewählter Fahrer",
    "scout_distribution": "Verteilung nach Slot",
    "scout_variety": "Vielfalt der Liga",
    "scout_distinct": "Ausgewählte unterschiedliche Fahrer",
    "scout_identical": "Identische Aufstellungen",
    "scout_no_picks": "Triff deine Auswahl, um zu sehen, wie viele dieselbe Aufstellung wie du haben",
    "loading_lineups": "Aufstellungen werden geladen...",
    "collapse_all": "ALLES SCHLIESSEN",
    "expand_all": "ALLES ÖFFNEN",
    "no_races": "Derzeit sind keine Rennen verfügbar.",
    "add_rider_one": "+ Fahrer hinzufügen ({{current}}/{{limit}})",
    "duplicate_rider": "{{name}} wurde bereits in einer vorherigen Etappe aufgestellt!",
    "draft_count": "Du hast {{count}} Fahrer lokal gespeichert",
    "toast_multi": "Auswahl für {{count}} Ligen gespeichert",
    "scout_chosen_by": "Gewählt von: {{names}}",
    "scout_chosen_by_others": "Gewählt von: {{names}} und {{count}} weiteren",
    "scout_sharing": "Wird geteilt...",
    "scout_share_btn": "Scouting-Bericht teilen",
    "scout_outsider": "Außenseiter",
    "scout_contrarian": "Mutigste Wahl",
    "scout_slot": "SLOT {{n}}",
    "scout_players": "{{count}} Spieler",
    "draft_unsaved_banner": "Auswahl nicht bestätigt — drücke auf Bestätigen, um sie zu speichern",
    "draft_unsaved_title": "Auswahl nicht bestätigt",
    "draft_unsaved_body": "Du hast eine nicht gespeicherte Auswahl. Möchtest du die Auswahl bestätigen, bevor du fortfährst?",
    "draft_exit": "Ohne Speichern verlassen",
    "draft_confirm_now": "Bleiben und bestätigen",
    "share_all": "Alle",
    "current_league": "Aktuelle Liga",
    "duplicate_rider_reason": "Bereits verwendet: {{name}}",
    "flip_saved": "Flip gespeichert!",
    "flip_deleted": "Flip entfernt.",
    "flip_add_rider": "+ Flip-Fahrer hinzufügen (optional)",
    "riders_count_one": "1 Fahrer",
    "riders_count_many": "{{count}} Fahrer",
    "riders_count_other": "{{count}} Fahrer",
    "riders_selected_one": "1 ausgewählt",
    "riders_selected_many": "{{count}} ausgewählt",
    "riders_selected_other": "{{count}} ausgewählt",
    "search_user": "Benutzer suchen...",
    "tab_per_tappa": "Nach Etappe",
    "tab_matrice": "Fahrerpräsenz",
    "matrix_select_riders": "Wähle die zu verfolgenden Fahrer aus (max. 5)",
    "no_picks_riepilogo": "Keine Auswahl gefunden",
    "no_picks_riepilogo_sub": "Du hast für dieses Rennen noch keine Auswahl getroffen.",
    "scout_avg_pct": "~{{pct}}% im Durchschnitt",
    "scout_no_identical": "Niemand sonst hat dieselbe Aufstellung wie du",
    "scout_identical_count_one": "1 Spieler hat dieselbe Aufstellung wie du",
    "scout_identical_count_many": "{{count}} Spieler haben dieselbe Aufstellung wie du",
    "scout_identical_count_other": "{{count}} Spieler haben dieselbe Aufstellung wie du",
    "scout_share_dialog": "Scouting-Bericht — {{name}}",
    "share_hidden": "+ {{count}} WEITERE SPIELER · APP ÖFFNEN",
    "no_picks_tabella": "Keine Aufstellung übermittelt",
    "no_picks_tabella_sub": "Die Auswahlen der anderen Spieler erscheinen hier.",
    "flip_slot_arrow": "→ Slot {{slot}}",
    "race_tag_pick": "TIPP",
    "race_tag_live": "LIVE",
    "race_tag_done": "BEENDET",
    "race_switcher_label": "Rennen",
    "race_history": "Rennverlauf",
    "race_group_next": "Kommende",
    "race_group_past": "Vergangene",
    "close": "Schließen",
    "prev_stage": "Vorherige Etappe",
    "next_stage": "Nächste Etappe",
    "stage_list_title": "Etappen",
    "matrix_chosen_by": "{{name}} · von {{count}} von {{total}} getippt",
    "matrix_clear": "Auswahl aufheben",
    "matrix_chosen_by_a11y": "von {{count}} von {{total}} Spielern getippt",
    "matrix_open_player": "Tipps von {{name}} öffnen",
    "sheet_chosen_by": "{{count}} von {{total}}",
    "sheet_shared": "Wie du",
    "sheet_unique": "Einzigartiger Tipp",
    "share_label": "DIE TIPPS",
    "share_most_picked": "AM HÄUFIGSTEN",
    "share_unique_picks": "EINZIGARTIGE TIPPS",
    "share_unique_sub": "Fahrer, die nur einer getippt hat",
    "scout2_title": "Scout",
    "scout2_originality": "DEINE ORIGINALITÄT",
    "scout2_twin": "DEIN ZWILLING",
    "scout2_identical": "IDENTISCHE TIPPS",
    "scout2_identical_sub": "Spieler mit demselben Tipp",
    "scout2_bold": "Mutig",
    "scout2_balanced": "Ausgewogen",
    "scout2_aligned": "Angepasst",
    "scout2_in_common": "{{count}} von {{total}} gemeinsam",
    "scout2_none": "Keiner",
    "scout2_popularity": "Beliebtheit der Fahrer",
    "scout2_tap_hint": "Tippe auf einen Fahrer, um ihn in der Tabelle hervorzuheben",
    "scout2_your_picks": "Deine Tipps",
    "scout2_also_by": "Auch getippt von {{names}}",
    "scout2_only_you": "Nur du",
    "scout2_outsiders": "Außenseiter",
    "finished_banner": "Rennen beendet · du bist {{pos}}. mit {{pts}} Pkt",
    "finished_banner_nopos": "Rennen beendet",
    "finished_cta": "Rangliste",
    "scout2_like_you": "Wer wie du getippt hat",
    "scout2_twins_card": "DEINE ZWILLINGE",
    "scout2_same_as_you": "{{count}} mit deinem Tipp",
    "scout2_same_picks": "Gleicher Tipp",
    "scout2_group_count": "{{count}} Spieler",
    "scout2_no_common": "Keine gemeinsamen Fahrer mit",
    "scout2_other_identical": "Weitere identische Tipps",
    "result_title": "Wie es lief",
    "result_total": "Du hast {{pts}} Pkt geholt",
    "result_pick_line": "getippt {{slot}}. · angekommen {{rank}}.",
    "result_dnf": "nicht klassiert",
    "result_best": "Dein Bester",
    "result_worst": "Hat dich am meisten gekostet",
    "result_malus": "Sieger nicht getippt",
    "result_bonus_top10": "Alle in den Top 10",
    "result_bonus_top15": "Alle in den Top 15",
    "result_winner": "Der Sieger",
    "result_winner_owners": "von {{count}} von {{total}} getippt",
    "result_nobody": "Niemand hatte ihn",
    "result_difference": "Hat den Unterschied gemacht",
    "result_difference_sub": "wer ihn hatte, holte im Schnitt {{delta}} Pkt im Vergleich zu den anderen",
    "result_flop": "Hat viele versenkt",
    "result_flop_sub": "wer ihn hatte, holte im Schnitt {{delta}} Pkt im Vergleich zu den anderen",
    "rules_title": "Regeln kurz",
    "rules_1": "Ein Fahrer pro Etappe, drei bei Zeitfahren.",
    "rules_2": "Ein Fahrer kann im selben Rennen nicht zweimal verwendet werden.",
    "rules_3": "Wenn du auch nur eine Etappe auslässt, bist du raus: Du kannst zusehen, aber nicht spielen.",
    "rules_flip": "Flip: nur einmal pro Rennen nennst du einen Ersatzfahrer; er zählt anstelle des Stammfahrers nur, wenn er besser ankommt.",
    "profile_flat": "Flach",
    "profile_hilly": "Hügelig",
    "profile_mountain": "Berg",
    "profile_itt": "Zeitfahren",
    "profile_ttt": "Mannschaftszeitfahren",
    "view_by_rider": "Nach Fahrer",
    "view_by_player": "Nach Spieler",
    "tour_summary": "{{riders}} Fahrer von {{players}} Spielern getippt",
    "your_pick": "Dein Tipp",
    "tour_your_result": "Dein Ergebnis",
    "tour_stage_winner": "Etappensieger",
    "stage_finished_banner": "Etappe beendet · du bist {{pos}}. der Etappe ({{gap}})",
    "share_label_stage": "DIE TIPPS DER ETAPPE",
    "share_distinct_riders": "VERSCHIEDENE FAHRER",
    "scout_t_position": "DU BIST IN DER",
    "scout_t_break": "AUSREISSERGRUPPE",
    "scout_t_small": "KLEINEN GRUPPE",
    "scout_t_group": "HAUPTFELD",
    "scout_t_with": "mit {{count}} Spielern",
    "scout_t_alone": "nur du",
    "scout_t_leader": "DER LEADER TIPPTE",
    "scout_t_jerseys": "Die Trikots: was sie getippt haben",
    "scout_t_breakaway": "In der Ausreißergruppe",
    "closes_at": "Schließt {{when}}",
    "closes_in": "Schließt in {{time}}",
    "profile_title": "Höhenprofil",
    "profile_climbs": "Anstiege",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Höhenprofil: {{km}} km, höchster Punkt {{max}} m, {{n}} Hauptanstiege",
    "profile_sprint": "S = Zwischensprint",
    "profile_tap_climb": "Anstieg antippen für Details",
    "profile_sprint_bonus": "Sprint · Bonus",
    "climb_base": "Fuß",
    "climb_summit": "Gipfel",
    "climb_avg": "Durchschnittssteigung",
    "climb_length": "Länge",
    "profile_bonus": "B = Bonuspunkt"
  },
  "join": {
    "back_home": "Zurück zur Startseite",
    "welcome": "Willkommen in der Liga!",
    "already_member": "Du bist bereits Mitglied dieser Liga.",
    "error": "Beitritt zur Liga nicht möglich.",
    "joining": "Zugriff auf die Liga...",
    "success": "Zugriff erfolgt!"
  },
  "leaderboard": {
    "stage_cancelled": "Etappe {{n}} abgesagt: zählt nicht für die Wertung",
    "loading": "Wird geladen...",
    "no_result_title": "Kein Ergebnis",
    "no_result_sub": "Die Ergebnisse dieses Rennens sind noch nicht verfügbar.",
    "gc_rank": "Gesamtwertung",
    "team_no_data": "Keine Teamdaten für diese Etappe.",
    "team_title": "TEAM-WERTUNG",
    "stage": "Etappe {{n}}",
    "general": "Gesamt",
    "stage_rank": "Etappenwertung {{n}}",
    "no_data_title": "Daten nicht verfügbar",
    "no_data_sub": "Die Wertung für diese Etappe wurde noch nicht berechnet.",
    "one_day_race": "Eintagesrennen",
    "title": "Rangliste",
    "no_data": "Keine Daten verfügbar.",
    "share": "Teilen",
    "jersey_tempo": "Zeit",
    "jersey_punti": "Punkte",
    "jersey_gpm": "Bergwertung",
    "tab_individual": "Einzelwertung",
    "tab_team": "Team",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "LÄUFT",
    "race_tag_done": "BEENDET",
    "race_tag_soon": "BALD",
    "leader_label": "Im Trikot",
    "lead_over_second": "{{gap}} auf Platz 2",
    "winner": "Sieger",
    "sheet_total": "Gesamt",
    "tie": "punktgleich",
    "top10_count": "{{count}} in den Top 10",
    "has_winner": "Hat den Sieger",
    "my_rank": "Deine Platzierung",
    "counts_for_team": "Zählt für das Team",
    "not_counting": "Zählt nicht",
    "share_label": "RANGLISTE",
    "gap_above": "{{gap}} auf Platz {{pos}}",
    "gap_below": "{{gap}} vor Platz {{pos}}",
    "trend_up": "{{n}} Plätze gestiegen",
    "trend_down": "{{n}} Plätze gefallen",
    "trend_same": "Platzierung unverändert",
    "sheet_by_stage": "Etappe für Etappe"
  },
  "leagues": {
    "albo": "Ehrentafel",
    "no_podio": "hat noch keine Podestplätze erreicht.",
    "victories": "Siege",
    "second": "2. Platz",
    "third": "3. Platz",
    "races_count_one": "1 Rennen",
    "races_count_many": "{{count}} Rennen",
    "races_count_other": "{{count}} Rennen",
    "player_a": "-- Spieler A --",
    "player_b": "-- Spieler B --",
    "draws_one": "1 Unentschieden",
    "draws_many": "{{count}} Unentschieden",
    "draws_other": "{{count}} Unentschieden",
    "on_races_one": "bei 1 Rennen",
    "on_races_many": "bei {{count}} Rennen",
    "on_races_other": "bei {{count}} Rennen",
    "no_common": "Kein gemeinsames Rennen mit Ergebnissen.",
    "settings": "EINSTELLUNGEN",
    "your_position": "Deine Position",
    "stagionale": "Saisonwertung",
    "hide": "AUSBLENDEN",
    "show_all_one": "ALLE ANZEIGEN (1 weitere/r)",
    "show_all_many": "ALLE ANZEIGEN ({{count}} weitere)",
    "show_all_other": "ALLE ANZEIGEN ({{count}} weitere)",
    "no_data": "Noch keine Daten verfügbar.",
    "head2head": "Direktvergleich",
    "races_count": "{{count}} Rennen",
    "draws": "{{count}} Unentschieden",
    "on_races": "bei {{count}} Rennen",
    "show_all": "ALLE ANZEIGEN ({{count}} weitere)",
    "badge_empty_1": "Noch keine Abzeichen — der Ruhm wartet auf dich! 🚴",
    "badge_empty_2": "Bisher keine Erfolge, aber jedes Rennen ist eine Chance. 💪",
    "badge_empty_3": "Immer noch keine Abzeichen — große Champions starten bei null. 🏅",
    "badge_empty_4": "Das erste Abzeichen ist immer das schwierigste. Fast geschafft! ⚡",
    "gap_to_podium": "{{gap}} Pkt bis zum Podium",
    "gap_to_prev": "{{gap}} Pkt hinter Platz {{pos}}",
    "lead_over_next": "+{{gap}} Pkt vor Platz {{pos}}",
    "invite_title": "Allein unterwegs?",
    "invite_body": "Lade deine Freunde ein, in dieser Liga zusammen zu spielen.",
    "invite_cta": "Freunde einladen",
    "pick_member": "Spieler wählen",
    "position_a11y": "Platz {{pos}}",
    "load_error": "Liga konnte nicht geladen werden.",
    "tab_standings": "Rangliste",
    "tab_stats": "Statistik",
    "tab_rivalry": "Duelle"
  },
  "league": {
    "member_count_one": "1 Benutzer in dieser Liga",
    "member_count_many": "{{count}} Benutzer in dieser Liga",
    "member_count_other": "{{count}} Benutzer in dieser Liga",
    "index_join": "Beitreten",
    "index_create": "Liga erstellen",
    "manage_title": "Verwaltung {{name}}",
    "err_name": "Gib einen Namen ein",
    "err_password": "Gib ein Passwort ein",
    "err_creation": "Fehler beim Erstellen",
    "create_title": "Neue Liga erstellen",
    "create": "Liga erstellen",
    "privacy": "Datenschutz",
    "public": "Öffentlich",
    "private": "Privat",
    "err_join": "Fehler oder du bist bereits angemeldet",
    "join_title": "Einer Liga beitreten",
    "search_placeholder": "Nach Name suchen...",
    "search": "Suchen",
    "no_leagues_found": "Keine Liga gefunden",
    "join_btn": "Beitreten",
    "password_insert": "Passwort eingeben:",
    "calendar_section": "Kalender",
    "calendar_desc_admin": "Verwalte die Rennen der Liga",
    "calendar_desc_user": "Rennen im Kalender",
    "manage": "Verwalten",
    "view": "Anzeigen",
    "calendar_title": "Ligakalender",
    "calendar_save_one": "Kalender speichern (1 Rennen)",
    "calendar_save_many": "Kalender speichern ({{count}} Rennen)",
    "calendar_save_other": "Kalender speichern ({{count}} Rennen)",
    "races_selected_one": "1 Rennen ausgewählt",
    "races_selected_many": "{{count}} Rennen ausgewählt",
    "races_selected_other": "{{count}} Rennen ausgewählt",
    "deselect_all": "Alle abwählen",
    "select_all": "Alle auswählen",
    "loading": "Wird geladen...",
    "settings_section": "Ligaeinstellungen",
    "settings_name": "Name der Liga",
    "settings_save": "Speichern",
    "settings_autopick": "Automatische Auswahl",
    "settings_autopick_desc": "Trifft ein Benutzer keine Auswahl, wählt das System automatisch den besten verfügbaren Fahrer der vorherigen Etappe.",
    "settings_team_race": "Mannschaftsrennen",
    "settings_team_race_desc": "Aktiviert den Team-Modus für diese Liga.",
    "settings_team_size": "Max. Mitglieder pro Team",
    "settings_scoring": "Punkteberechnung",
    "settings_scoring_best2": "Beste 2 — Summe der besten zwei",
    "settings_scoring_avg": "Durchschnitt aller Mitglieder",
    "settings_flip": "Flip",
    "settings_flip_desc": "Jeder Benutzer kann für eine beliebige Etappe einen Joker-Fahrer angeben. Bei der Punkteberechnung wird automatisch der bessere Wert zwischen Stammfahrer und Flip gewählt. Pro Rennen nur einmal verwendbar.",
    "invite_section": "Einladungslink",
    "invite_loading": "Wird geladen...",
    "invite_copied": "Kopiert!",
    "invite_copy": "Kopieren",
    "invite_share_btn": "Teilen",
    "members_section": "Mitglieder",
    "members_title_admin": "Mitgliederverwaltung",
    "members_title_user": "Mitglieder der Liga",
    "leaving": "Wird verlassen...",
    "leave": "Diese Liga verlassen",
    "admin_badge": "Admin",
    "remove": "Entfernen",
    "pick_admin_title": "Auswahlkorrektur",
    "pick_admin_desc": "Bearbeite die Auswahlen der Benutzer",
    "pick_admin_open": "Öffnen",
    "pick_admin_save": "Auswahl speichern",
    "pick_admin_none": "— keiner —",
    "pick_admin_search": "Fahrer oder Startnummer suchen",
    "pick_admin_retired": "ausgestiegen",
    "pick_admin_saved2": "{{set}} Tipps gesetzt, {{removed}} entfernt",
    "pick_admin_nochange": "Keine Änderungen zu speichern",
    "pick_admin_undo": "Letzte Korrektur rückgängig",
    "pick_admin_undone": "Korrektur rückgängig gemacht",
    "pick_admin_future": "Außerdem wurden {{n}} Tipps späterer Etappen mit demselben Fahrer entfernt",
    "pick_admin_notify": "Spieler benachrichtigen",
    "pick_admin_no_calendar": "Dieses Rennen ist nicht im Liga-Kalender: Speichern nicht möglich",
    "stats_section": "Statistiken",
    "stats_participation": "Teilnahme pro Etappe",
    "stats_title": "Teilnahmestatistiken",
    "stats_no_data": "Keine Daten verfügbar.",
    "stats_error": "Statistiken konnten nicht geladen werden. Versuche es erneut.",
    "team_loading": "Team wird geladen...",
    "team_section": "Team",
    "team_cancel": "Abbrechen",
    "team_create_btn": "+ Team erstellen",
    "team_locked": "Rennen läuft — Team-Änderungen deaktiviert",
    "team_create": "Team erstellen",
    "team_members_count_one": "1/{{max}} Mitglied",
    "team_members_count_many": "{{count}}/{{max}} Mitglieder",
    "team_members_count_other": "{{count}}/{{max}} Mitglieder",
    "team_invite_btn": "+ Einladen",
    "team_leave": "Verlassen",
    "team_save": "Speichern",
    "team_pwd_hint": "Leer lassen, um öffentlich zu machen",
    "team_pending": "Warte auf Antwort",
    "team_invite_cancel": "Abbrechen",
    "team_invite_section": "Ein Mitglied einladen",
    "team_no_invitable": "Kein Mitglied verfügbar, um es einzuladen.",
    "team_invite_action": "Einladen",
    "team_private_label": "\"{{name}}\" ist privat:",
    "team_join_action": "Beitreten",
    "team_empty": "Noch kein Team vorhanden — sei der/die Erste, der/die eines erstellt!",
    "team_mine": "DEIN TEAM",
    "team_join": "Beitreten",
    "team_full": "Voll",
    "team_members": "Mitglieder",
    "join": "Beitreten",
    "calendar_save": "Kalender speichern ({{count}} Rennen)",
    "invite_share": "Teilen",
    "races_selected": "{{count}} Rennen ausgewählt",
    "invite_desc": "Teile diesen Link — wer klickt, tritt direkt der Liga bei.",
    "invite_desc_pwd": "Teile diesen Link — wer klickt, tritt direkt der Liga bei, mit bereits enthaltenem Passwort.",
    "member_count": "{{count}} Benutzer in dieser Liga",
    "team_members_count": "{{count}}/{{max}} Mitglieder",
    "create_name_placeholder": "Z. B.: Die Pedalfreunde",
    "create_password_placeholder": "Zugangspasswort",
    "calendar_saved": "Kalender gespeichert!",
    "err_name_empty": "Der Name darf nicht leer sein",
    "settings_saved": "Einstellungen gespeichert!",
    "pwd_public_placeholder": "Leer lassen für eine öffentliche Liga",
    "invite_share_title": "Tritt {{name}} auf Virtua Cycling bei",
    "invite_share_message": "Tritt der Liga \"{{name}}\" auf Virtua Cycling bei!\n{{url}}",
    "invite_regen_confirm": "Link neu generieren? Alle vorherigen Links funktionieren dann nicht mehr.",
    "invite_regenerating": "Wird neu generiert...",
    "invite_regen_btn": "Link neu generieren (widerruft vorherige)",
    "confirm_remove": "{{name}} aus der Liga entfernen?",
    "member_removed": "{{name}} entfernt",
    "confirm_demote": "Möchtest du {{name}} die Admin-Rechte entziehen?",
    "confirm_promote": "Möchtest du {{name}} zum Admin befördern?",
    "demote_admin": "Admin entfernen",
    "promote_admin": "Admin",
    "pick_admin_saved": "{{count}} Auswahlen gespeichert!",
    "confirm_team_leave": "Team verlassen?",
    "confirm_kick": "{{name}} aus dem Team entfernen?",
    "team_invite_sent": "Einladung gesendet!",
    "team_pwd_saved": "Passwort aktualisiert!",
    "team_name_placeholder": "Teamname...",
    "team_rename_placeholder": "Neuer Name...",
    "team_newpwd_placeholder": "Neues Passwort..."
  },
  "profile": {
    "nick_title": "Spitzname",
    "theme_title": "Themenanpassung",
    "theme_dark": "Dunkel",
    "theme_light": "Hell",
    "lang": "Sprache",
    "save_lang": "Sprache speichern",
    "nick_success": "Spitzname aktualisiert!",
    "nick": "Spitzname",
    "nick_placeholder": "Spitzname eingeben",
    "update_btn": "Aktualisieren",
    "pass": "Passwort",
    "show_pass": "Passwort anzeigen",
    "update_pass": "Passwort aktualisieren",
    "avatars_title": "Avatare",
    "avatars": "Avatare anzeigen",
    "avatars_sub": "Schalte es aus, wenn dein Handy langsam ist: statt der Avatare siehst du die Trikots der Fahrer und die Namen der Spieler. Dein Avatar auf dem Startbildschirm bleibt.",
    "notif_title": "Push-Benachrichtigungen",
    "my_leagues": "Meine Ligen",
    "members_count_one": "1 Mitglied",
    "members_count_many": "{{count}} Mitglieder",
    "members_count_other": "{{count}} Mitglieder",
    "default_badge": "STANDARD",
    "set_default": "Als Standard festlegen",
    "leave": "Verlassen",
    "settings": "Profileinstellungen",
    "hi": "Hallo",
    "intro": "hier kannst du dein Konto verwalten.",
    "admin_panel": "Admin-Bereich",
    "theme_sub": "Auf allen deinen Geräten synchronisiert.",
    "lang_title": "Sprache / Language",
    "security_title": "Zugang und Sicherheit",
    "security_success": "Daten aktualisiert!",
    "notif_enabled": "Benachrichtigungen aktivieren",
    "notif_enabled_sub": "Aktiviert oder deaktiviert alle Benachrichtigungen",
    "notif_results": "Rennergebnisse",
    "notif_results_sub": "Benachrichtigung bei Veröffentlichung der Ergebnisse",
    "notif_startlist": "Startliste",
    "notif_startlist_sub": "Benachrichtigung, sobald die Startliste verfügbar ist",
    "notif_reminder": "Auswahl-Erinnerung",
    "notif_reminder_sub": "Erhalte eine Erinnerung vor Ablauf der Auswahlfrist",
    "notif_reminder_off": "Keine Erinnerung",
    "notif_reminder_no_pick": "Nur wenn ich noch nicht ausgewählt habe",
    "notif_reminder_always": "Immer",
    "notif_saving": "Wird gespeichert...",
    "notif_saved": "Einstellungen gespeichert!",
    "notif_error": "Fehler beim Speichern",
    "nick_taken": "Spitzname bereits vergeben",
    "pass_min_length": "Das Passwort muss mindestens 6 Zeichen lang sein",
    "pass_mismatch": "Die Passwörter stimmen nicht überein",
    "new_pass_placeholder": "Neues Passwort",
    "league_default_updated": "Standardliga aktualisiert!",
    "league_leave_confirm": "Bist du sicher, dass du \"{{name}}\" verlassen möchtest?",
    "league_left": "Liga verlassen.",
    "confirm_password": "Passwort bestätigen",
    "avatar_title": "Dein Avatar",
    "avatar_jersey": "Trikot",
    "avatar_cap": "Mütze",
    "avatar_glasses": "Brille",
    "avatar_cyclist": "Radfahrer",
    "avatar_patch": "Trikot-Patch",
    "avatar_saved": "Avatar gespeichert!",
    "avatar_save_btn": "Avatar speichern",
    "rules": "Regelwerk",
    "report_bug": "Problem melden",
    "bug_sent": "Meldung gesendet, danke!",
    "bug_placeholder": "Beschreibe das Problem...",
    "group_identity": "Identität",
    "group_account": "Konto",
    "group_contact": "Kontakt",
    "group_danger": "Gefahrenzone",
    "change_pass": "Ändern",
    "cancel": "Abbrechen",
    "show_more": "Alle anzeigen ({{count}} weitere)",
    "show_less": "Weniger anzeigen",
    "delete_confirm": "Möchtest du dein Konto wirklich löschen? Diese Aktion ist unwiderruflich und alle deine Daten werden endgültig gelöscht.",
    "delete_desc": "Das Löschen ist dauerhaft und entfernt alle deine Daten, Tipps, Ligen und Einstellungen.",
    "delete_btn": "Mein Konto löschen",
    "delete_league_owner": "Du hast eine Liga mit weiteren Mitgliedern erstellt: Mit dem Löschen deines Kontos verschwindet sie für alle. Kontaktiere uns, um sie zu übertragen, oder lösche sie vorher.",
    "replay_tour": "Tour erneut ansehen",
    "leave_feedback": "Feedback geben",
    "feedback_placeholder": "Eine Idee, ein Vorschlag oder ein Kommentar: wir freuen uns darauf...",
    "feedback_sent": "Danke für dein Feedback! 🙏",
    "rate_app": "Virtua Cycling bewerten ⭐"
  },
  "login": {
    "err_nickname": "Gib einen Spitznamen ein",
    "err_nickname_taken": "Spitzname bereits vergeben",
    "register_ok": "Registration completed! Check your email and confirm your account before logging in.",
    "err_email": "Gib deine E-Mail ein",
    "forgot_sent": "E-Mail gesendet! Überprüfe dein Postfach.",
    "tagline": "Nimm deinen Platz im Begleitfahrzeug ein.",
    "tab_login": "Anmelden",
    "tab_register": "Registrieren",
    "forgot_hint": "Gib deine E-Mail ein und wir senden dir einen Link zum Zurücksetzen des Passworts.",
    "email": "E-Mail",
    "forgot_send": "Link senden",
    "back": "← Zurück zur Anmeldung",
    "nickname": "Spitzname",
    "password": "Passwort",
    "btn_login": "ANMELDEN",
    "btn_register": "REGISTRIEREN",
    "forgot_pass": "Passwort vergessen?",
    "or": "oder",
    "google_login": "Mit Google anmelden",
    "google_register": "Mit Google registrieren",
    "privacy_text": "Wenn du fortfährst, akzeptierst du unsere",
    "privacy_link": "Datenschutzrichtlinie",
    "loading": "…"
  },
  "news": {
    "title": "NEUIGKEITEN",
    "loading": "Wird geladen...",
    "no_news": "Keine Neuigkeiten verfügbar.",
    "pinned": "Hervorgehoben",
    "not_found": "Artikel nicht gefunden.",
    "open_external": "Artikel auf {{source}} öffnen",
    "disclaimer": "Überschriften und Links stammen aus externen Quellen: Die Artikel gehören den jeweiligen Verlagen.",
    "tab_unread_one": "{{count}} neue Meldung",
    "tab_unread_other": "{{count}} neue Meldungen",
    "load_error": "Die News konnten nicht geladen werden."
  },
  "reset_password": {
    "title": "NEUES PASSWORT",
    "subtitle": "Wähle ein neues Passwort für dein Konto",
    "show_pass": "Passwort anzeigen",
    "loading": "Link wird überprüft...",
    "success": "Passwort aktualisiert! Du wirst weitergeleitet..."
  },
  "confirm": {
    "verifying": "Wird überprüft...",
    "error": "Fehler bei der Bestätigung.",
    "success": "E-Mail bestätigt! Du wirst weitergeleitet...",
    "missing_params": "Fehlende Parameter im Link.",
    "missing_params_detail": "Stelle sicher, dass du auf den richtigen Link aus deiner E-Mail geklickt hast.",
    "critical_error": "Kritischer Verbindungsfehler."
  },
  "notifications": {
    "title": "Benachrichtigungen",
    "empty": "Noch keine Benachrichtigungen",
    "accept": "Annehmen",
    "refuse": "Ablehnen",
    "now": "Jetzt",
    "minutes_ago": "vor {{count}} Min.",
    "hours_ago": "vor {{count}} Std."
  },
  "quiz": {
    "card_sub": "10 Fragen zur Tour de France — wie viel weißt du?",
    "loading": "Fragen werden geladen...",
    "no_questions": "Keine Frage verfügbar",
    "question_count": "Frage {{current}} von {{total}}",
    "easy": "Leicht",
    "medium": "Mittel",
    "hard": "Schwer",
    "correct": "Richtige Antwort!",
    "wrong": "Falsch. Die richtige Antwort war: {{answer}}",
    "next": "Nächste",
    "see_result": "Ergebnis ansehen",
    "restart": "Erneut spielen",
    "result_excellent": "Du bist ein echter Radsport-Experte!",
    "result_good": "Ausgezeichnete Kenntnisse der Tour de France!",
    "result_average": "Solide Kenntnisse. Schau dir mehr Rennen an!",
    "result_poor": "Da geht noch was — aber genau dafür wird ja getreten!"
  },
  "person": {
    "hint": "Wähle das Aussehen deines Avatars: du siehst ihn auf der Startseite.",
    "gender": "Geschlecht",
    "man": "Mann",
    "woman": "Frau",
    "hair_short": "Kurz",
    "hair_curly": "Lockig",
    "hair_wavy": "Wellig",
    "hair_shaved": "Rasiert",
    "hair_pixie": "Pixie",
    "hair_bob": "Bob",
    "headwear": "Kopfbedeckung",
    "wear_none": "Keine",
    "wear_cap": "Kappe",
    "wear_helmet": "Helm",
    "glasses": "Brille",
    "glasses_off": "Nein",
    "glasses_on": "Ja",
    "jersey": "Trikot",
    "jersey_vertical": "Vertikal",
    "jersey_horizontal": "Horizontal",
    "jersey_classic": "Klassisch",
    "jersey_diagonal": "Diagonal",
    "jersey_dots": "Punkte",
    "row_skin": "Haut",
    "row_hair": "Haare",
    "row_brow": "Augenbrauen",
    "row_iris": "Augen",
    "row_wear": "Kopfbedeckung",
    "row_visor": "Schirm",
    "row_vents": "Lüftungsöffnungen",
    "row_frame": "Brillenfassung",
    "save": "SPEICHERN",
    "saved": "Avatar gespeichert",
    "save_error": "Fehler beim Speichern",
    "reset": "Zurücksetzen",
    "reset_done": "Zurückgesetzt",
    "tab_face": "Gesicht",
    "tab_hair": "Haare",
    "tab_gear": "Zubehör",
    "tab_jersey": "Trikot",
    "row_lens": "Gläser",
    "jersey_body": "Körper",
    "jersey_sleeves": "Ärmel",
    "jersey_band": "Streifen",
    "jersey_trim": "Kragen & Bündchen",
    "view_mine": "Mein Avatar",
    "view_world_champion": "Regenbogentrikot",
    "world_champion_since": "Weltmeister in {{league}} seit {{date}}",
    "view_european_champion": "Europameistertrikot",
    "european_champion_since": "Europameister in {{league}} seit {{date}}",
    "view_worldcup_leader": "Weltcup-Trikot",
    "worldcup_leader_since": "Führender der Rangliste von {{league}} seit {{date}}",
    "kits_show": "Show team kits (admin)",
    "kits_hide": "Hide team kits",
    "kits_hint": "Team jerseys imported from PCS: check colours and design. Kits are fixed in the database.",
    "kits_approx": "approximate",
    "kits_men": "Men",
    "kits_women": "Women",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tap a team to see its riders",
    "kits_no_riders": "No avatars for this team yet.",
    "avatar_edit": "Avatar bearbeiten",
    "avatar_cut": "Schnitt",
    "avatar_hair": "Haare",
    "avatar_skin": "Haut",
    "avatar_beard": "Bart",
    "avatar_beard_none": "Keiner",
    "avatar_face": "Gesicht",
    "avatar_face_none": "Standard",
    "avatar_face_a": "Schmal",
    "avatar_face_b": "Kräftig",
    "avatar_face_c": "Jung",
    "avatar_face_d": "Kantig",
    "avatar_face_e": "Reif",
    "avatar_face_f": "Lächelnd",
    "avatar_face_g": "Geschlossenes Lächeln",
    "avatar_brow": "Augenbrauen",
    "avatar_brow_0": "Normal",
    "avatar_brow_1": "Dünn",
    "avatar_brow_2": "Dicht",
    "avatar_beard_light": "Leicht",
    "avatar_hex": "Andere Farbe (#RRGGBB)",
    "avatar_save": "Speichern",
    "avatar_reset": "Zurücksetzen",
    "avatar_undo": "Letzte Änderung rückgängig",
    "avatar_saved": "Gespeichert",
    "avatar_bad_hex": "Ungültige Farbe: #RRGGBB verwenden",
    "avatar_err": "Speichern fehlgeschlagen",
    "avatar_beard_legend": "1 Schatten · 2 Schnurrbart · 3 kurz · 4 voll · 6 Schnurrbart+Spitzbart · 7 Kreis · 8 Dreitagebart",
    "hair_wavy_medium": "Mittellang gewellt",
    "hair_receding": "Geheimratsecken",
    "hair_messy": "Zerzaust",
    "hair_buzz": "Ganz kurz",
    "hair_curly_short": "Kurze Locken",
    "hair_medium": "Schulterlang",
    "hair_flip_off": "Normale Seite",
    "hair_flip_on": "Gespiegelt",
    "hair_side_part": "Seitenscheitel",
    "hair_slicked_back": "Nach hinten",
    "hair_forward": "Nach vorne",
    "hair_high_line": "Hoher Haaransatz",
    "hair_wavy_short": "Kurz gewellt",
    "hair_curly_medium": "Mittellange Locken",
    "hair_receding_short": "Kurz mit Geheimratsecken",
    "beard_stubble_light": "Dreitagebart",
    "hair_long": "Lang",
    "hair_ponytail": "Pferdeschwanz",
    "hair_bun": "Dutt",
    "hair_long_wavy": "Gewellt",
    "hair_braid": "Zopf",
    "beard": "Bart",
    "beard_none": "Keiner",
    "beard_stubble": "Schatten",
    "beard_moustache": "Schnurrbart",
    "beard_short": "Kurz",
    "beard_full": "Voll",
    "beard_goatee": "Schnurrbart und Spitzbart",
    "beard_circle": "Kreisbart",
    "beard_op_normal": "Normal",
    "beard_op_light": "Leicht",
    "fringe": "Pony",
    "fringe_off": "Ohne",
    "fringe_on": "Mit Pony"
  },
  "app_update": {
    "title": "Neue Version bereit",
    "body": "Starte die App neu, um die Neuerungen zu nutzen.",
    "restart": "Neu starten",
    "later": "Später"
  },
  "avatar": {
    "invite_title": "Hier ist dein Avatar!",
    "invite_body": "Wir haben einen für dich erstellt: gestalte ihn, wie du willst.",
    "invite_cta": "Anpassen",
    "invite_dismiss": "Schließen",
    "edit_a11y": "Passe deinen Avatar an"
  },
  "jersey_celebration": {
    "ok": "Super!"
  },
  "insight": {
    "you": "Mit dir",
    "form": "Form",
    "never": "Noch nie von dir gewählt: es wäre das erste Mal.",
    "picked": "Mal gewählt",
    "avg_rank": "Ø Platzierung",
    "avg_gap": "Ø Rückstand",
    "best": "Bestes Ergebnis",
    "dnf": "Aufgaben mit dir",
    "last": "Zuletzt",
    "retired": "aufgegeben",
    "form_avg": "Ø der letzten 5",
    "season_races": "Rennen in der Saison",
    "top10": "Top 10",
    "wins": "Siege",
    "dnfs": "Aufgaben",
    "cat_1": "Flachetappen",
    "cat_2": "Bergetappen",
    "cat_3": "Hügelige Etappen",
    "last5": "Letzte 5 Ergebnisse",
    "no_results": "Noch keine Ergebnisse in dieser Saison.",
    "open_a11y": "Einblicke zu {{name}}",
    "summary": "{{n}}× mit dir · Ø {{rank}}.",
    "summary_never": "Noch nie von dir gewählt",
    "open": "Insights"
  },
  "badges": {
    "title": "Badges",
    "album_title": "Trophäenschrank",
    "earned_of": "{{earned}} von {{total}} Badges",
    "open_album": "Trophäenschrank öffnen",
    "recent": "Zuletzt erhalten",
    "next_goals": "Ziele in Reichweite",
    "filter_all": "Alle",
    "filter_earned": "Erhalten",
    "filter_todo": "Noch offen",
    "group_gt": "Grand Tours",
    "group_monuments": "Monumente & Klassiker",
    "group_picks": "Tippkunst",
    "group_consistency": "Beständigkeit",
    "group_league": "Ligawertung",
    "group_social": "Sozial",
    "group_meta": "Sammlung",
    "tier_1": "Bronze",
    "tier_2": "Silber",
    "tier_3": "Gold",
    "tier_4": "Platin",
    "tier_special": "Meilenstein",
    "secret_title": "Geheimes Badge",
    "secret_hint": "Finde es spielend heraus.",
    "earned_on": "Erhalten am {{date}}",
    "progress": "{{value}} von {{threshold}}",
    "rarity": "{{pct}} % der Liga haben es ({{n}} von {{m}})",
    "rarity_none": "Noch niemand hat es: Du könntest der Erste sein.",
    "seasons": "Erhaltene Saisons: {{count}}",
    "complete": "Abgeschlossen",
    "locked": "Noch offen",
    "player": "Spieler",
    "none_me": "Noch keine Badges: Das nächste Rennen ist deine Chance.",
    "none_other": "{{name}} hat noch keine Badges.",
    "empty_filter": "Mit diesem Filter gibt es nichts anzuzeigen.",
    "load_error": "Badges konnten nicht geladen werden.",
    "not_enabled": "Badges sind für diese Liga noch nicht aktiv.",
    "fam": {
      "RE_GT": {
        "title": "König der Grand Tours",
        "desc": "Gewonnene Grand Tours: {{n}}"
      },
      "WIN_GIRO": {
        "title": "König des Giro",
        "desc": "Gewinne die Gesamtwertung des Giro d'Italia"
      },
      "WIN_TOUR": {
        "title": "König der Tour",
        "desc": "Gewinne die Gesamtwertung der Tour de France"
      },
      "WIN_VUELTA": {
        "title": "König der Vuelta",
        "desc": "Gewinne die Gesamtwertung der Vuelta"
      },
      "GT_PODI": {
        "title": "Podien bei Grand Tours",
        "desc": "Podiumsplätze bei Grand Tours: {{n}}"
      },
      "GT_DAYS": {
        "title": "Tage im Trikot",
        "desc": "Tage als Spitzenreiter der Gesamtwertung: {{n}}"
      },
      "FIRST_PINK": {
        "title": "Rosa Trikot",
        "desc": "Übernimm die Führung in der Gesamtwertung des Giro d'Italia"
      },
      "FIRST_YELLOW": {
        "title": "Gelbes Trikot",
        "desc": "Übernimm die Führung in der Gesamtwertung der Tour de France"
      },
      "FIRST_RED": {
        "title": "Rotes Trikot",
        "desc": "Übernimm die Führung in der Gesamtwertung der Vuelta"
      },
      "GT_GREEN": {
        "title": "König der Sprinter",
        "desc": "Gewonnene Punktewertungen bei Grand Tours: {{n}}"
      },
      "GT_POIS": {
        "title": "König der Berge",
        "desc": "Gewonnene Bergwertungen bei Grand Tours: {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Etappenjäger",
        "desc": "Gewonnene Etappen bei Grand Tours: {{n}}"
      },
      "GT_WIRE": {
        "title": "Von Anfang bis Ende",
        "desc": "Führe die Gesamtwertung von der ersten bis zur letzten Etappe an und gewinne die Grand Tour"
      },
      "GT_COMEBACK": {
        "title": "Aufholjagd",
        "desc": "Gewinne eine Grand Tour, obwohl du nach der ersten Woche nicht in den Top 10 warst"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Totaler Triumph",
        "desc": "Gewinne Gesamt-, Punkte- und Bergwertung bei derselben Grand Tour"
      },
      "GT_HEARTBREAK": {
        "title": "Die Enttäuschung",
        "desc": "Du hast am Vorabend der letzten Etappe geführt, aber die Grand Tour nicht gewonnen"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Crown",
        "desc": "Gewinne Giro, Tour und Vuelta"
      },
      "THE_DOUBLE": {
        "title": "The Double",
        "desc": "Gewinne Giro und Tour im selben Jahr"
      },
      "RE_MONUMENTI": {
        "title": "König der Monumente",
        "desc": "Gewonnene Monumente: {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Gewinne Mailand–Sanremo"
      },
      "WIN_FIANDRE": {
        "title": "Die Flandern-Rundfahrt",
        "desc": "Gewinne die Flandern-Rundfahrt"
      },
      "WIN_ROUBAIX": {
        "title": "Hölle des Nordens",
        "desc": "Gewinne Paris–Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Doyenne",
        "desc": "Gewinne Lüttich–Bastogne–Lüttich"
      },
      "WIN_LOMBARDIA": {
        "title": "Rennen der fallenden Blätter",
        "desc": "Gewinne die Lombardei-Rundfahrt"
      },
      "MONUMENTS_SWEEP": {
        "title": "Alle Monumente",
        "desc": "Gewinne alle 5 Monumente"
      },
      "RE_DEL_NORD": {
        "title": "König des Nordens",
        "desc": "Gewinne Flandern und Roubaix im selben Jahr"
      },
      "ARDENNES": {
        "title": "Ardennen-Triple",
        "desc": "Gewinne Amstel, Flèche Wallonne und Lüttich im selben Jahr"
      },
      "DUE_MARI": {
        "title": "Rennen der zwei Meere",
        "desc": "Gewinne Paris–Nizza und Tirreno–Adriatico im selben Jahr"
      },
      "MODALITA_POGACAR": {
        "title": "Pogačar-Modus",
        "desc": "Gewinne alle 3 Grand Tours und alle 5 Monumente"
      },
      "RE_CLASSICHE": {
        "title": "König der Klassiker",
        "desc": "Gewonnene Klassiker: {{n}}"
      },
      "RE_TAPPE": {
        "title": "König der Etappenrennen",
        "desc": "Gewonnene Etappenrennen: {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "Weltmeister",
        "desc": "Gewinne das Straßenrennen der Weltmeisterschaften"
      },
      "EURO_CHAMP": {
        "title": "Europameister",
        "desc": "Gewinne das Straßenrennen der Europameisterschaften"
      },
      "CRONOMAN": {
        "title": "Zeitfahrer",
        "desc": "Gewinne ein Zeitfahren der Welt- oder Europameisterschaften"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Als Einziger der Liga den Sieger getippt: {{n}}"
      },
      "PROFETA": {
        "title": "Prophet",
        "desc": "Gewinnende Tipps: {{n}}"
      },
      "FIUTO": {
        "title": "Riecher",
        "desc": "Von wenigen getippte Sieger: {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Rennsieger",
        "desc": "Gewonnene Rennen in der Liga: {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Podiumsstammgast",
        "desc": "Podiumsplätze in Ligarennen: {{n}}"
      },
      "DEBUTTO": {
        "title": "Debüt",
        "desc": "Fahre dein erstes Rennen"
      },
      "PRESENZE": {
        "title": "Anwesenheit",
        "desc": "Gespielte Rennen: {{n}}"
      },
      "SERIE": {
        "title": "In Serie",
        "desc": "Gespielte Rennen in Folge: {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Perfekte Saison",
        "desc": "Spiele jedes Rennen der Saison"
      },
      "LEADER_STAGIONE": {
        "title": "Am Ruder",
        "desc": "Rennen an der Spitze der Wertung beendet: {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "Ligameister",
        "desc": "Beende die Saison auf Platz 1 der Wertung"
      },
      "PODIO_LEGA": {
        "title": "Liga-Podium",
        "desc": "Beende die Saison auf dem Podium der Wertung"
      },
      "TOP10_LEGA": {
        "title": "Top 10",
        "desc": "Beende die Saison unter den ersten 10 der Wertung"
      },
      "SCALATORE": {
        "title": "Kletterer",
        "desc": "In einem einzigen Rennen gewonnene Plätze: {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Riesentöter",
        "desc": "Rennen vor dem Führenden der Wertung beendet: {{n}}"
      },
      "ALBUM": {
        "title": "Album",
        "desc": "Erhaltene Badges: {{n}}"
      },
      "LEGGENDA": {
        "title": "Legende",
        "desc": "Hol dir alle Badges"
      }
    },
    "celebration_one": "Neues Badge!",
    "celebration_many": "{{n}} neue Badges!",
    "celebration_more": "und {{n}} weitere",
    "share": "Teilen",
    "share_label": "BADGE ERHALTEN",
    "share_dialog": "Mein Badge: {{name}}",
    "share_text": "Ich habe das Badge „{{name}}“ bei Virtua Cycling erhalten! {{site}}",
    "showcase_title": "Highlights",
    "showcase_hint": "Wähle bis zu 3 Badges zum Vorzeigen. Ohne Auswahl zeigen wir deine seltensten.",
    "showcase_edit": "Bearbeiten",
    "showcase_auto": "Automatisch",
    "showcase_save": "Speichern",
    "showcase_count": "{{n}} von 3 gewählt",
    "showcase_err": "Die Auswahl konnte nicht gespeichert werden.",
    "showcase_a11y": "Deine Highlight-Badges",
    "showcase_none": "Hol dir dein erstes Badge, um es hier zu sehen.",
    "showcase_pick_empty": "Du hast noch keine Badges für die Vitrine.",
    "jerseys_title": "Trikots der Grand Tours",
    "jersey_pink": "Rosa Trikot",
    "jersey_yellow": "Gelbes Trikot",
    "jersey_red": "Rotes Trikot",
    "days_caption": "Tage im Trikot",
    "section_jerseys": "Trikots",
    "special_title": "Spezialtrikots",
    "special_now": "Aktuell getragen",
    "trophy_sub": "Badges, Trikots und Ehrentafel"
  },
  "rivalry": {
    "title": "Duelle",
    "intro": "Wähle einen Gegner. Wenn er annimmt, bekommt ab diesem Rennen den Punkt, wer vor dem anderen ins Ziel kommt. Die ganze Liga sieht den Stand.",
    "slots": "Gestartete Duelle: {{used}} von {{max}}",
    "limit_reached": "Du hast die maximale Zahl an Duellen gestartet. Brich eines ab oder beende es, um ein neues zu starten.",
    "no_candidates": "Es gibt keine weiteren Spieler zum Herausfordern.",
    "challenge_cta": "Duell starten",
    "pick_title": "Wen willst du herausfordern?",
    "confirm_challenge": "{{name}} herausfordern? Die Anfrage wird zugestellt und kann angenommen oder abgelehnt werden.",
    "sent": "Anfrage an {{name}} gesendet.",
    "accepted": "Du hast das Duell mit {{name}} angenommen.",
    "incoming_title": "Erhaltene Anfragen",
    "incoming_line": "{{name}} fordert dich heraus",
    "accept": "Annehmen",
    "decline": "Ablehnen",
    "waiting_title": "Warten auf Antwort",
    "waiting_line": "Warten auf {{name}}",
    "cancel": "Abbrechen",
    "mine_title": "Deine Duelle",
    "league_title": "In der Liga",
    "ended_title": "Beendete Duelle: {{count}}",
    "empty": "Keine laufenden Duelle in der Liga. Starte das erste!",
    "vs": "gegen",
    "score_a11y": "{{a}} zu {{b}}",
    "last_point": "Letzter Punkt: {{name}} bei {{race}}",
    "no_races": "Noch keine Rennen",
    "won_by": "Gewonnen von {{name}}",
    "drawn": "Unentschieden beendet",
    "detail_title": "Duell",
    "results_title": "Rennen für Rennen",
    "no_results": "Noch kein Punkt vergeben.",
    "point_to": "Punkt für {{name}}",
    "end_cta": "Duell beenden",
    "end_confirm": "Duell mit {{name}} beenden?",
    "rematch": "Revanche",
    "load_error": "Duelle konnten nicht geladen werden.",
    "err_limit": "Du hast bereits die maximale Zahl an Duellen gestartet.",
    "err_exists": "Ihr seid schon im Duell, oder eine Anfrage läuft.",
    "err_invalid": "Diese Anfrage ist nicht mehr gültig.",
    "err_generic": "Die Aktion konnte nicht abgeschlossen werden.",
    "notif_accepted": "Duell angenommen",
    "notif_declined": "Duell abgelehnt"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Wettbewerb"
  },
  "no_league": {
    "title": "Du nimmst an keiner {{comp}}-Liga teil",
    "body": "Du kannst einer Liga beitreten oder im Bereich Ligen eine neue erstellen.",
    "body_official": "Du kannst der offiziellen Liga jederzeit beitreten oder im Bereich Ligen einer privaten Liga beitreten oder eine erstellen.",
    "join": "{{name}} beitreten",
    "go_leagues": "Zu den Ligen"
  }
}
